import React from 'react';

export const ReadMoreArrow = () => {
  return (
    <svg className='fr-blog-card__cta-tag-icon' xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
      <path id="Polygon_19" data-name="Polygon 19" d="M8,0l8,12H0Z" transform="translate(12) rotate(90)" fill="#fff"/>
    </svg>
  )
}